export const startLoading = () => {
    return {
        type: 'START_LOADING',
        showLoading: true
    };
};

export const endLoading = () => {
    return {
        type: 'END_LOADING',
        showLoading: false
    };
};

export const startProcessing = (text) => {
    return {
        type: 'START_PROCESSING',
        showProcessing: true,
        textProcessing: text
    };
};

export const endProcessing = () => {
    return {
        type: 'END_PROCESSING',
        showProcessing: false
    };
};